import { Checkbox } from '@/components/ui/checkbox'
import { FormField } from '@/components/ui/form'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import FieldWrapper from './FieldWrapper'
import { useContext } from 'react'
import { FormEntityContext } from '../../config/context/forms'
import { FieldProps } from './types'

const CheckboxField = ({
  name,
  customDescription,
  customLabel,
  className,
  layout = 'box',
  disabled = false,
  onChange,
}: FieldProps<boolean>) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FieldWrapper
            className={`${
              layout === 'inline'
                ? 'inline-flex flex-row-reverse items-center gap-2'
                : ''
            } ${className ?? ''}`.trim()}
            layout={layout}
            keepRowOnMobile
            label={
              customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
            }
            description={
              customDescription ??
              t(`${i18nPrefix}.${entityType}.${name}.description`)
            }
          >
            <Checkbox
              checked={field.value}
              disabled={disabled}
              onCheckedChange={(value) => {
                const checked = value === true
                field.onChange(checked)
                onChange?.(checked)
              }}
            />
          </FieldWrapper>
        )
      }}
    />
  )
}

export default CheckboxField
